import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import roRO from 'antd/locale/ro_RO';
import App from './App';
import { useSessionBootstrap } from './hooks/useSessionBootstrap';
import './index.css';

function BootstrapGate({ children }: { children: React.ReactNode }) {
  const ready = useSessionBootstrap();

  if (!ready) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  return <>{children}</>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={roRO}
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
        },
      }}
    >
      <BrowserRouter>
        <BootstrapGate>
          <App />
        </BootstrapGate>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>,
);
